// Autogenerated file, DO NOT MODIFY or it will be overwritten;
import type { SVGProps } from 'react';

import { forwardRef } from '@chakra-ui/react';

import { Icon, type IconProps } from '../Icon';

const Svg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      stroke="#6F7881"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M9.9974 5.0013V10.0013L13.3307 11.668M18.3307 10.0013C18.3307 14.6037 14.5998 18.3346 9.9974 18.3346C5.39502 18.3346 1.66406 14.6037 1.66406 10.0013C1.66406 5.39893 5.39502 1.66797 9.9974 1.66797C14.5998 1.66797 18.3307 5.39893 18.3307 10.0013Z"
    />
  </svg>
);
const IconHourOutline = forwardRef((props: Omit<IconProps, 'icon'>, ref) => {
  return <Icon ref={ref} icon={Svg} {...props} />;
});
export default IconHourOutline;
